module.exports = __webpack_public_path__ + "img/hopways.d34c6fa9.webp";